import React from 'react';
import ReactDOM from 'react-dom';
import {Router} from 'react-router-dom';
import { Provider } from 'react-redux';
import './index.css';
import { history } from './History';
import App from './App';
import { store } from './store';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
ReactDOM.render(
  <React.StrictMode>
      <Provider store={store}>
      <Router history={history}>
    <App />
    </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
